import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { UntypedFormArray, UntypedFormGroup } from '@angular/forms';
import { CodelistService } from '@common/services/codelist.service';
import { DeliveryOrderService } from '@common/services/delivery-order.service';
import { ModalService } from '@common/services/modal.service';
import { marker } from '@common/translate-marker';
import { TranslateService } from '@ngx-translate/core';
import { DialogRef } from '@progress/kendo-angular-dialog';
import { ToastService } from '@services/toast.service';
import { DeliveryOrderItemsDisplayModel } from 'app/vessel-visit/delivery-order-list/models/DeliveryOrderItems.display.model';

@Component({
    selector: 'app-add-delivery-order-item',
    templateUrl: './add-delivery-order-item.component.html',
    styleUrls: ['./add-delivery-order-item.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AddDeliveryOrderItemComponent implements OnInit {
    isBusy: boolean;
    deliveryOrderItemsModel: DeliveryOrderItemsDisplayModel = new DeliveryOrderItemsDisplayModel();
    form: UntypedFormGroup;
    itemsArray: UntypedFormArray;
    deliveryOrderId = 0;
    isEditMode = false;
    deliveryOrderItemId = 0;
    selectedDeliveryOrderItem: DeliveryOrderItemsDisplayModel;

    constructor(
        public dialogService: ModalService,
        public activeModal: DialogRef,
        private translateService: TranslateService,
        private toastyService: ToastService,
        public service: DeliveryOrderService,
        public codelistService: CodelistService
    ) {}

    ngOnInit() {
        this.itemsArray = new UntypedFormArray([]);
        this.form = new UntypedFormGroup({
            items: this.itemsArray
        });

        this.checkEditMode();
        if (!this.isEditMode) {
            this.addItem();
        }
    }

    checkEditMode() {
        if (this.deliveryOrderItemId) {
            this.isEditMode = true;
            this.loadDeliveryOrderItem(this.deliveryOrderItemId);
        }
    }

    addItem() {
        this.itemsArray.push(this.deliveryOrderItemsModel.generateGroup());
    }

    removeItem(index: number) {
        this.itemsArray.removeAt(index);
    }

    addNewDeliveryOrder() {
        const items = this.itemsArray.controls.map((g: UntypedFormGroup) => g.getRawValue());
        let payload: any[] = [];

        if (this.isEditMode) {
            const item = { ...items[0], deliveryOrderId: this.deliveryOrderId, id: this.deliveryOrderItemId };
            payload = [item];
        } else {
            if (!items || items.length === 0) return;
            payload = items.map((it) => ({ ...it, deliveryOrderId: this.deliveryOrderId }));
        }

        this.service.addDeliveryOrderItems(payload).subscribe(
            () => {
                this.toastyService.success(this.translateService.instant(marker('Delivery order item(s) added')));
                this.activeModal.close(payload);
            },
            () => {
                this.toastyService.error(this.translateService.instant(marker('Error saving delivery order item(s)')));
            }
        );
    }

    loadDeliveryOrderItem(deliveryOrderItemId: number) {
        this.service.getSingleDeliveryOrderItem(deliveryOrderItemId).subscribe((item) => {
            this.selectedDeliveryOrderItem = item;
            this.itemsArray.clear();
            const group = this.deliveryOrderItemsModel.generateGroup();
            group.patchValue(item);
            this.itemsArray.push(group);
        });
    }
}
